// extracted by mini-css-extract-plugin
export var brand = "_9s-9";
export var compact = "_9s-6";
export var extraSmall = "_9s-7";
export var icon = "_9s-0";
export var large = "_9s-4";
export var light = "_9s-1";
export var medium = "_9s-5";
export var outline = "_9s-b";
export var primaryDark = "_9s-a";
export var primaryLight = "_9s-8";
export var primaryModern = "_9s-c";
export var success = "_9s-2";
export var successSolid = "_9s-3";